<template>
  <div id="carousel-front" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li data-target="#carousel-front" data-slide-to="0" class="active"></li>
      <li data-target="#carousel-front" data-slide-to="1"></li>
      <li data-target="#carousel-front" data-slide-to="2"></li>
      <li data-target="#carousel-front" data-slide-to="3"></li>
      <li data-target="#carousel-front" data-slide-to="4"></li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item active" @click="goToLink()">
        <img src="../../assets/img/home/topo_2.png" class="d-block w-100">
      </div>
      <div class="carousel-item">
        <img src="../../assets/img/home/topo_3.png" class="d-block w-100">
      </div>
      <div class="carousel-item">
        <img src="../../assets/img/home/topo_4.png" class="d-block w-100">
      </div>
    </div>
    <a class="carousel-control-prev" href="#carousel-front" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Anterior</span>
    </a>
    <a class="carousel-control-next" href="#carousel-front" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Próximo</span>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    goToLink: function() {
      window.open('https://www.akdemica.com.br/cursos/')
    }
  }
}
</script>

<style>

</style>
